'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Options;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Options(_ref) {
  var pages = _ref.pages;
  var options = [];
  var count = 1;

  while (count <= pages) {
    options.push(_react2.default.createElement('option', {
      key: count
    }, count));
    count += 1;
  }

  return options;
}

Options.propTypes = {
  pages: _propTypes2.default.number.isRequired
};